<template>
    <!-- Dialog hiển thị lịch sử tác động phiếu nghỉ phép (đồng bộ với module phiếu làm thêm) -->
    <v-dialog v-model="dialog" max-width="1200px" scrollable>
        <v-card class="rounded-xl">
            <!-- Thanh tiêu đề -->
            <v-card-title class="text-h6 font-weight-bold py-4 px-6 d-flex align-center">
                <v-icon color="teal darken-4" class="mr-2">mdi-history</v-icon>
                Lịch sử tác động phiếu nghỉ phép
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <!-- Khung tìm kiếm và bảng dữ liệu lịch sử -->
            <v-card-text class="px-6 py-4">
                <!-- Ô tìm kiếm nhanh nhật ký tác động -->
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Tìm kiếm nhanh..."
                    single-line
                    hide-details
                    outlined
                    dense
                    color="teal darken-4"
                    class="mb-4 bg-white rounded-lg"
                ></v-text-field>

                <!-- Bảng danh sách nhật ký tác động -->
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :search="search"
                    :loading="isLoading"
                    loading-text="Đang tải dữ liệu lịch sử..."
                    no-data-text="Không có lịch sử tác động nào."
                    class="elevation-1 rounded-lg"
                    :footer-props="{
                        itemsPerPageText: 'Số dòng mỗi trang:',
                        itemsPerPageOptions: [10, 20, 50, 100]
                    }"
                >
                    <!-- Định dạng cột thời gian -->
                    <template v-slot:[`item.createdAt`]="{ item }">
                        <span>{{ formatDateTime(item.createdAt || item.CreatedAt) }}</span>
                    </template>

                    <!-- Định dạng người thực hiện (Tên + Mã) -->
                    <template v-slot:[`item.creator`]="{ item }">
                        <div class="font-weight-medium">
                            {{ item.createdByName || item.CreatedByName || item.createdBy || item.CreatedBy || '--' }}
                        </div>
                        <div
                            v-if="(item.createdByName || item.CreatedByName) && (item.createdBy || item.CreatedBy)"
                            class="caption grey--text"
                        >
                            {{ item.createdBy || item.CreatedBy }}
                        </div>
                    </template>

                    <!-- Định dạng hành động (Duyệt, Từ chối, Tạo mới, ...) -->
                    <template v-slot:[`item.action`]="{ item }">
                        <v-chip small color="teal lighten-5" text-color="teal darken-4" class="font-weight-bold">
                            {{ item.action || item.Action }}
                        </v-chip>
                    </template>

                    <!-- Định dạng Mã phiếu -->
                    <template v-slot:[`item.targetCode`]="{ item }">
                        <span class="font-weight-medium teal--text text--darken-4">
                            {{ item.targetCode || item.TargetCode || '--' }}
                        </span>
                    </template>

                    <!-- Định dạng thông tin tóm tắt -->
                    <template v-slot:[`item.shortData`]="{ item }">
                        <div class="text-truncate" style="max-width: 250px;" :title="item.shortData || item.ShortData">
                            {{ item.shortData || item.ShortData }}
                        </div>
                    </template>

                    <!-- Định dạng ghi chú tác động -->
                    <template v-slot:[`item.note`]="{ item }">
                        <div
                            class="text-truncate grey--text text--darken-2 text-caption"
                            style="max-width: 250px;"
                            :title="item.note || item.Note"
                        >
                            {{ item.note || item.Note }}
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import http from "@/components/services/http-common";
import * as moment from "moment/moment";

export default {
    name: "LeaveHistoryDialog",
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // Ràng buộc 2 chiều trạng thái mở/đóng dialog
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
    watch: {
        // Tự động tải dữ liệu lịch sử khi mở dialog
        value(val) {
            if (val) {
                this.fetchHistory();
            }
        }
    },
    data() {
        return {
            isLoading: false,
            search: "",
            items: [],
            // Các cột hiển thị trên bảng lịch sử tác động
            headers: [
                { text: "Thời gian", value: "createdAt", width: "160px", sortable: true },
                { text: "Người thực hiện", value: "creator", width: "180px", sortable: true },
                { text: "Hành động", value: "action", width: "120px", sortable: true },
                { text: "Mã phiếu", value: "targetCode", width: "130px", sortable: true },
                { text: "Đối tượng", value: "resource", width: "130px", sortable: true },
                { text: "Liên quan", value: "belongTo", width: "120px", sortable: true },
                { text: "Thông tin nhanh", value: "shortData", sortable: false },
                { text: "Ghi chú", value: "note", sortable: false }
            ]
        };
    },
    methods: {
        // Định dạng ngày giờ dạng DD/MM/YYYY HH:mm:ss
        formatDateTime(value) {
            if (!value) return "";
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        // Gọi API tải lịch sử tác động từ leaveRequests/history
        fetchHistory() {
            this.isLoading = true;
            http.get("leaveRequests/history")
                .then(res => {
                    const data = res.data;
                    if (data && data.results) {
                        this.items = data.results;
                    } else if (data && data.items) {
                        this.items = data.items;
                    } else if (data && data.data) {
                        this.items = data.data;
                    } else if (Array.isArray(data)) {
                        this.items = data;
                    } else {
                        this.items = [];
                    }
                })
                .catch(err => {
                    console.error("Lỗi khi tải lịch sử phiếu nghỉ phép:", err);
                    // Dự phòng gọi endpoint leaverequests/history nếu chữ hoa/thường khác biệt
                    if (err.response && err.response.status === 404) {
                        return http
                            .get("leaverequests/history")
                            .then(res => {
                                const data = res.data;
                                this.items =
                                    (data && (data.results || data.items || data.data)) ||
                                    (Array.isArray(data) ? data : []);
                            })
                            .catch(e => {
                                console.error("Lỗi fallback lịch sử nghỉ phép:", e);
                            });
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>

<style scoped>
.text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
